import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameState } from "./GameState";

export class GameWonLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "game-won-layer");

        const backgroundSprite: Phaser.Sprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("lila-square"));
        backgroundSprite.scale.setTo(GameConstants.GAME_WIDTH / 16, GameVars.gameHeight / 16);
        backgroundSprite.alpha = 0;
        this.add(backgroundSprite);
        
        this.game.add.tween(backgroundSprite)
                .to({alpha: .8}, 450, Phaser.Easing.Cubic.Out, true);
        
        const gameWonLabel = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 290, "texture_atlas_3", "txt_congratulations.png");
        gameWonLabel.anchor.setTo(.5);
        gameWonLabel.alpha = 0;
        gameWonLabel.scale.x = GameVars.scaleX;
        this.add(gameWonLabel);

        let wonStr: string;

        if (GameVars.language === GameConstants.LANGUAGE_FRENCH) {
            wonStr = "Tu as gagné!";
        } else {
            wonStr = "You've won!";
        }
        
        const youVeWonLabel: Phaser.BitmapText = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 360, "marker-felt", wonStr, 40);
        youVeWonLabel.scale.x = GameVars.scaleX;
        youVeWonLabel.x -= youVeWonLabel.width / 2;
        youVeWonLabel.alpha = 0;
        this.add(youVeWonLabel);
        
        this.game.add.tween(gameWonLabel)
            .to({alpha: 1 }, 600, Phaser.Easing.Cubic.Out, true, 900)
            .onComplete.add(function(): void {
                var star: Phaser.Image = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 290, "texture_atlas_1", "star.png");
                star.blendMode = 3;
                star.anchor.setTo(.5);
                star.scale.setTo(.25 * GameVars.scaleX, .25);
                this.addAt(star, 1);
                
                this.game.add.tween(star.scale)
                    .to({x: GameVars.scaleX, y: 1 }, 1200, Phaser.Easing.Cubic.Out, true);
            }, this);

        this.game.add.tween(youVeWonLabel)
            .to({alpha: 1 }, 600, Phaser.Easing.Cubic.Out, true, 2100)
            .onComplete.add(function(): void {
                this.showPlayTime();
                this.replay();
            }, this);
    }
    
    private showPlayTime(): void {
        
        const playTime = GameConstants.TIME - GameVars.getInstance().time;

        let completedStr: string;
        let recordStr: string;

        if (GameVars.language === GameConstants.LANGUAGE_FRENCH) {
            completedStr = "Terminé en ";
            recordStr = "Votre record est ";
        } else {
            completedStr = "Completed in ";
            recordStr = "Your record is ";
        }
        
        const completedLabel = new Phaser.BitmapText(this.game, 
        GameConstants.GAME_WIDTH / 2, 482, "marker-felt", completedStr + GameVars.getInstance().formatTime(playTime), 50);
        completedLabel.scale.x = GameVars.scaleX;
        completedLabel.x -= completedLabel.width / 2;
        this.add(completedLabel);
        
        const recordLabel = new Phaser.BitmapText(this.game, 
        GameConstants.GAME_WIDTH / 2, 555, "marker-felt", recordStr + GameVars.getInstance().formatTime(GameVars.getInstance().bestTime), 36);
        recordLabel.scale.x = GameVars.scaleX;
        recordLabel.x -= recordLabel.width / 2;
        recordLabel.tint = 0xcccccc;
        this.add(recordLabel);
    }
    
    private replay(): void {
    
        if (!AudioManager.getInstance().isAudioMuted) {
            AudioManager.getInstance().mute();
        }
        var that = this;
        PokiSDK.gameplayStop();
        PokiSDK.commercialBreak().then(
            () => {
                console.log("Commercial break finished, proceeding to game");
                PokiSDK.gameplayStart();

                if (!AudioManager.getInstance().isAudioMuted) {
                    AudioManager.getInstance().unmute();
                }
                that.game.time.events.add(4600, function(): void {
                    GameState.currentInstance.replay();
                }, that);
            }
        );
    }
}
